import './style.scss'
export default function InfoBlock3() {

    return <div id="about" className="info-block-3">
        <div className="info-block-3__wrapper container">
            <h2 className="info-block-3__title title" data-aos="fade-up">Where Data Becomes Strategy</h2>
            <div className="info-block-3__items" data-aos="fade-up">
                <p>We are actively implementing artificial intelligence and machine learning to analyze large volumes of data. </p>
                <p>Thus, our clients retain their competitive advantage and receive stable profits even in periods of high volatility.</p>
                <p>This allows us to predict market trends more accurately and react quickly to changes in the market environment. </p>
            </div>
        </div>
    </div>
}